import {connect} from "react-redux";
import useUpdateSureTax from "../look/hooks/useUpdateSureTax";

const ShoppingCartSureTaxUpdater = (props) => {

  const {visualizersLoadedLength, cartItems, fabricatorSettings, isPhoneNumberValidated, jobId} = props;

  const runUpdates = fabricatorSettings.sureTax && isPhoneNumberValidated && jobId;
  //added jobId because first we need to register and finish saving the quote

  useUpdateSureTax(visualizersLoadedLength, cartItems, runUpdates, false);

  return null
};

const mapStateToProps = (store) => {
  const {visualizersLoaded, jobId} = store.serverState;
  const {cartItems, sureTax} = store.cartState;
  const {isPhoneNumberValidated} = store.userState;
  const {settings} = store.fabricatorState;

  return {
    visualizersLoadedLength: visualizersLoaded.length,
    cartItems,
    sureTax,
    fabricatorSettings: settings,
    isPhoneNumberValidated,
    jobId,
  };
};

export default (
  connect(mapStateToProps)(ShoppingCartSureTaxUpdater)
)
